import values from 'utils/values'

import { AppDropdownOptionType, AppDropdownProps } from './AppDropdown'

import global from 'scss/global.module.scss'
import styles from './AppDropdown.module.scss'

const helper = {
  init: (props: AppDropdownProps) => {
    const result = [styles.dropdown]

    if (props.multiple) {
      result.push(styles.multiple)
    }
    
    return result
  },

  initWrapper: (props: AppDropdownProps) => {
    const result = [styles.wrapper]

    return result
  },

  initDropdown: (props: AppDropdownProps) => {
    const result = [styles.dropdownList]

    return result
  },

  active: (active: boolean) => {
    return active ? styles.active : null
  },

  flex: (props: AppDropdownProps) => {
    const defaultValue = null
    const value = values.classWithPrefix(props.flex, 'f')
    return (value ? global[value] : defaultValue)
  },

  size: (props: AppDropdownProps) => {
    const defaultValue = null
    return (props.large ? styles.large : null)
      ?? (props.small ? styles.small : null)
      ?? defaultValue
  },

  widthClass: (props: AppDropdownProps) => {
    const defaultValue = global.wFull
    return (props.full ? global.wFull : null)
      ?? (props.fullWidth ? global.wFull : null)
      ?? (props.halfWidth ? global.wHalf : null)
      ?? defaultValue
  },

  heightClass: (props: AppDropdownProps) => {
    const defaultValue = global.hAuto
    return (props.full ? global.hFull : null)
      ?? (props.fullHeight ? global.hFull : null)
      ?? (props.halfHeight ? global.hHalf : null)
      ?? defaultValue
  },

  width: (props: AppDropdownProps) => {
    const defaultValue = null
    const value = values.px(props.width)
    return value ?? defaultValue
  },

  height: (props: AppDropdownProps) => {
    const defaultValue = null
    const value = values.px(props.height)
    return value ?? defaultValue
  },

  disabled: (props: AppDropdownProps) => {
    const defaultValue = null
    return (props.disabled ? styles.disabled : defaultValue)
  },

  error: (props: AppDropdownProps) => {
    const defaultValue = null
    return (props?.error && (props.error !== '' || props?.danger) ? styles.error : defaultValue)
  },

  option: (props: AppDropdownProps, value: AppDropdownOptionType['value'], disabled: boolean, hovered: boolean) => {
    const result = [styles.option]

    if (disabled) {
      result.push(styles.disabled)
    }

    if (hovered) {
      result.push(styles.hovered)
    }

    if (props.multiple && Array.isArray(props.value) && (props.value as any[]).includes(value) || props.value === value) {
      result.push(styles.active)
    }

    return result
  },
}

export default helper